import React from 'react';
import styled from 'styled-components';
import { Itunes, SoundCloud, Spotify } from 'gatsby-theme-pdv/src/components/icons';

const Sharing = ({
  soundcloudButtonLink,
  audioButtonLink,
  itunesButtonLink,
}) => {
  if (!soundcloudButtonLink && !audioButtonLink && !itunesButtonLink) {
    return null;
  }
  return (
    <StyledSharing>
      Luister via:
      {soundcloudButtonLink && (
        <a href={soundcloudButtonLink}>
          <SoundCloud />
        </a>
      )}
      {audioButtonLink && (
        <a href={audioButtonLink}>
          <Spotify />
        </a>
      )}
      {itunesButtonLink && (
        <a href={itunesButtonLink}>
          <Itunes />
        </a>
      )}
    </StyledSharing>
  );
};

const StyledSharing = styled.div`
  display: flex;
  align-items: center;
  margin-top: 20px;
  a {
    display: flex;
    justify-content: center;
    background-color: ${(props) => props.theme.primaryColor};
    border-radius: 50%;
    width: 42px;
    height: 42px;
    margin-left: 15px;
    &:hover {
      background-color: ${(props) => props.theme.gray4};
    }
    svg {
      align-self: center;
      height: 25px;
      color: ${(props) => props.theme.gray1};
    }
  }
`;

export default Sharing;
